/**
 * Die wenigen Anordnungen, die in mehreren Karten gleich aussehen.
 *
 * Bewusst **kein** zweites Gestaltungssystem: Hier steht nur Anordnung — Abstand,
 * Trennlinie, Mindestbreite. Farben, Radien und Schriftgrößen kommen aus den
 * CSS-Variablen von `@hausmeter/ui`. Sobald eine dieser Listen ein eigenes
 * Verhalten bekommt, wird sie eine Komponente dort und verschwindet hier.
 */
import type { CSSProperties } from "react";

export const mutedText: CSSProperties = { color: "var(--text-muted)", fontSize: 13, margin: 0 };

export const plainList: CSSProperties = { listStyle: "none", padding: 0, margin: 0 };

export const listRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "var(--sp-3)",
  padding: "var(--sp-2) 0",
  borderTop: "1px solid var(--border-subtle)",
  flexWrap: "wrap",
};

/**
 * Die erste Spalte einer Zeile — gleiche Breite, damit die Liste eine Kante hat.
 *
 * **`min(150px, 100%)` und nicht `150px`.** Eine Mindestbreite ist eine
 * Untergrenze, die auch dann gilt, wenn daneben nichts mehr ist: Auf einem
 * schmalen Telefon schöbe die Beschriftung die Zeile über den Rand hinaus, und
 * die ganze Seite bekäme einen waagerechten Bildlauf. So bleibt die Kante,
 * solange es sie geben kann, und verschwindet, wenn es sie nicht geben kann.
 */
export const rowLabel: CSSProperties = {
  fontSize: 13,
  fontWeight: 600,
  minWidth: "min(150px, 100%)",
};
